<svg class="lt-sm:!hidden hide-xs" [attr.width]="width" [attr.height]="height">
  <g *ngFor="let h of hours; let idx = index" class="hour">
    <text x="0" [attr.y]="calcHourPos(idx)">{{ getHour(h) }}</text>
  </g>
  <g *ngFor="let t of timeline" class="timeline small">
    <line
      *ngIf="t % 6"
      [attr.x1]="width - w1"
      [attr.x2]="width"
      [attr.y1]="calcTimePos(t)"
      [attr.y2]="calcTimePos(t)"
    ></line>
  </g>
  <g *ngFor="let t of timeline" class="timeline">
    <line
      *ngIf="!(t % 6)"
      [attr.x1]="width - w2"
      [attr.x2]="width"
      [attr.y1]="calcTimePos(t)"
      [attr.y2]="calcTimePos(t)"
    ></line>
  </g>
</svg>

<svg class="gt-xs:!hidden hide-gt-xs" [attr.width]="widthXs" [attr.height]="height">
  <g *ngFor="let h of hours; let idx = index" class="hour">
    <text x="0" [attr.y]="calcHourPos(idx)">{{ getHour(h) }}</text>
  </g>
  <g *ngFor="let t of timeline" class="timeline small">
    <line
      *ngIf="t % 6"
      [attr.x1]="widthXs - w1Xs"
      [attr.x2]="widthXs"
      [attr.y1]="calcTimePos(t)"
      [attr.y2]="calcTimePos(t)"
    ></line>
  </g>
  <g *ngFor="let t of timeline" class="timeline">
    <line
      *ngIf="!(t % 6)"
      [attr.x1]="widthXs - w2Xs"
      [attr.x2]="widthXs"
      [attr.y1]="calcTimePos(t)"
      [attr.y2]="calcTimePos(t)"
    ></line>
  </g>
</svg>
